export default "__VITE_ASSET__De1bYYM8__"